var _clipPath, _foreignObject, _style, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logoClip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.481 0.539047C102.377 0.515625 98.2755 0.759163 94.2031 1.26812L99.7386 18.4339C101.909 18.2114 104.089 18.0811 106.27 18.0434C124.825 18.2642 142.678 25.1659 156.556 37.483C170.433 49.8002 179.406 66.7072 181.829 85.104C184.5 105.386 179.005 125.899 166.552 142.13C154.099 158.361 135.708 168.98 115.426 171.651C101.855 173.401 88.0636 171.51 75.4652 166.172C62.8668 160.834 51.915 152.241 43.7332 141.274L29.5766 151.487C39.6009 165.016 53.0531 175.626 68.5456 182.223C84.0381 188.819 101.01 191.163 117.71 189.012C130.033 187.389 141.916 183.356 152.68 177.141C163.443 170.926 172.878 162.652 180.444 152.791C188.01 142.93 193.56 131.675 196.776 119.669C199.992 107.664 200.813 95.1418 199.19 82.819C196.217 60.2468 185.207 39.5026 168.179 24.39C151.151 9.27753 129.246 0.809758 106.481 0.539047Z"
  }))), _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    width: 200,
    height: 200,
    clipPath: "url(#logoClip)"
  }, /*#__PURE__*/React.createElement("div", {
    id: "logo"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    div#logo {\n      width: 100%;\n      height: 100%;\n      background: conic-gradient(from -8deg, #ff45bd -8deg, #e445ff 104deg, #8745ff 216deg);\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2122 4.67245L58.9929 60.7753H0L47.7264 95.459L62.4787 84.732L53.3597 78.1158H71.587L77.2122 60.7753L82.8455 78.1158H101.083L86.3205 88.8214L92.4666 106.926L77.2122 95.4483L38.6048 123.505L36.6228 129.619L29.5606 151.351L29.5285 151.458C32.074 149.599 34.7344 147.689 37.718 145.541C41.1209 143.089 44.4277 140.709 47.235 138.674L77.2122 116.889L124.947 151.562L106.709 95.459L154.432 60.7753H95.4395L77.2122 4.67245Z",
    fill: "url(#paint0_linear_5_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2",
    x1: 165.988,
    y1: 264.171,
    x2: 237.011,
    y2: 166.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE445"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.66b8ff3d476f591bb417d8baafbb1876.svg";
export { ForwardRef as ReactComponent };